module.exports = __webpack_public_path__ + "image.c7048a2b41e56aa0f4d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image.png
// module id = 1396
// module chunks = 32